import { EyeCloseIcon, EyeOpenIcon } from "@/assets/icons";
import { IconButton } from "@/components/ui/IconButton";
import { useState } from "react";
import { Control, FieldPath, FieldValues } from "react-hook-form";
import ControlledInputField from "./ControlledInputField";
import InputField, { InputFieldProps } from "./InputField";

interface PasswordInputToggleFieldProps<TFieldValues extends FieldValues>
  extends Omit<InputFieldProps, "type" | "placeholder" | "endAdornment"> {
  control?: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  confirm?: boolean; // if true, this is a confirm password field
}

export default function PasswordInputToggleField<
  TFieldValues extends FieldValues,
>(props: PasswordInputToggleFieldProps<TFieldValues>) {
  const { control, confirm, ...otherProps } = props;
  const [show, setShow] = useState(false);
  const placeholder = confirm ? "Confirm Password" : "Enter Password";

  const commonProps = {
    ...otherProps,
    type: show ? "text" : "password",
    placeholder,
    endAdornment: (
      <IconButton
        size="sm"
        type="button"
        aria-label={show ? "Hide password" : "Show password"}
        className="flex items-center justify-center"
        onClick={() => setShow((v) => !v)}
      >
        {show ? <EyeOpenIcon /> : <EyeCloseIcon />}
      </IconButton>
    ),
  };

  if (control) {
    return <ControlledInputField {...commonProps} control={control} />;
  }

  return <InputField {...commonProps} />;
}
